import { useEffect, useState } from "react";
import FilterModal from "../FilterModal";
import DateInput from "../../forms/DateInput";
import FieldLabel from "../../forms/FieldLabel";
import ErrorLabel from "../../forms/base/ErrorLabel";
import {
  isCustomDateRangeValid,
  validateCustomDateRange,
} from "./utils/transactionHelpers";

function CustomTransactionDateRangeModal({
  isOpen,
  onClose,
  onApply,
  initialFromDate = "",
  initialToDate = "",
  copy,
}) {
  const [fromDate, setFromDate] = useState(initialFromDate);
  const [toDate, setToDate] = useState(initialToDate);
  const [error, setError] = useState("");

  useEffect(() => {
    if (isOpen) {
      setFromDate(initialFromDate);
      setToDate(initialToDate);
      setError("");
    }
  }, [initialFromDate, initialToDate, isOpen]);

  const isApplyDisabled = !isCustomDateRangeValid(
    fromDate,
    toDate,
    copy?.validation,
  );

  const handleApply = () => {
    const validationError = validateCustomDateRange(
      fromDate,
      toDate,
      copy?.validation,
    );
    if (validationError) {
      setError(validationError);
      return;
    }

    onApply({
      start_date: fromDate,
      end_date: toDate,
    });
  };

  return (
    <FilterModal
      isOpen={isOpen}
      onClose={onClose}
      onApply={handleApply}
      applyText={copy?.apply}
      applyDisabled={isApplyDisabled}
      title={copy?.title}
    >
      <div className="multiInputRaw">
        <div className="form-field">
          <FieldLabel label={copy?.from} htmlFor="customFromDate" />
          <DateInput
            id="customFromDate"
            name="fromDate"
            label={copy?.from_date}
            value={fromDate}
            maxDate={new Date()}
            onChange={(event) => {
              setFromDate(event.target.value);
              setError("");
            }}
          />
        </div>
        <div className="form-field">
          <FieldLabel label={copy?.to} htmlFor="customToDate" />
          <DateInput
            id="customToDate"
            name="toDate"
            label={copy?.to_date}
            value={toDate}
            maxDate={new Date()}
            onChange={(event) => {
              setToDate(event.target.value);
              setError("");
            }}
          />
        </div>
      </div>
      {error && <ErrorLabel fieldName={copy?.error_field}>{error}</ErrorLabel>}
    </FilterModal>
  );
}

export default CustomTransactionDateRangeModal;
